<template>
  <b-card>
    <b-card-title>My Permissions</b-card-title>
    <b-card-text>
      Your current account permissions are listed below.
    </b-card-text>
  </b-card>
</template>

<script>
import {
  BCard, BCardTitle, BCardText,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardTitle,
    BCardText,
  },
}
</script>
